<template>
  <div>nopower</div>
</template>

<script>
export default {
  name: 'nopower'
}
</script>
